"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestUtil = void 0;
const logger_1 = require("@linq/logger");
const uuid_1 = require("uuid");
class RequestUtil {
    /**
     * validates that id given is a valid UUID
     * @param id - id to check
     */
    static isValidId(id) {
        if (!id) {
            return false;
        }
        // validate the id is in UUID or GUID format
        const re = RegExp(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/);
        const match = re.exec(id);
        return match?.index === 0 && id.length === 36;
    }
    /**
     * Validates that a destination is valid.
     * can be one or more ClientId's or ChannelId's separated by semicolons
     * @param id The ID string to test
     * @returns true if the string is acceptable as an Id, false if not
     */
    static isValidDestination(id) {
        const reg = new RegExp('^#?[0-9a-z._]+$');
        // Check for multiple
        for (const i of id.split(';')) {
            if (!reg.test(i.trim())) {
                return false;
            }
        }
        return true;
    }
    /**
     * Validates an channelId string.
     * ChannelId's must begin with a pound character #, contain only the number characters 0-9,
     * the alpha characters a-z, a period (.), an underscore (_), or a dash (-)
     * Multiples are allowed if separated by a semicolon
     * @param id The ID string to test
     * @returns true if the string is acceptable as one or more channelId, false if not
     */
    static isValidChannel(id) {
        // Check for multiple
        for (const i of id.split(';')) {
            const reg = RegExp('^#[0-9a-z._-]+$');
            if (!reg.test(i.trim())) {
                return false;
            }
        }
        return true;
    }
    static getToken(bearerToken) {
        let token = bearerToken;
        if (!token) {
            throw new Error('no token given in authorization header');
        }
        token = token.replace('Bearer ', '');
        return token;
    }
    static getHeaders() {
        const correlationId = logger_1.RequestContext.store()?.get('correlationId') ?? uuid_1.v4();
        return { 'linq-correlation-id': correlationId };
    }
    static getTokenPayload() {
        const payload = logger_1.RequestContext.store()?.get('authorization') ?? {
            iss: '',
            sub: '',
            aud: '',
            iat: '',
            exp: 0,
            azp: '',
            scope: '',
            gty: '',
            permissions: [],
            role: '',
        };
        return payload;
    }
}
exports.RequestUtil = RequestUtil;
//# sourceMappingURL=RequestUtil.js.map